export interface AlertSettings {
    position: 'top' | 'bottom';
    useAnimation: boolean;
    opacity: number;
    duration: number;
}

export interface ChatSettings {
    chatPosition: 'top' | 'bottom';
    buttonPosition: 'top' | 'bottom';
    sound: boolean;
    opacity: number;
    archiveDays: number;
}

interface IDocumentSettings {
    booleanSettings: IBooleanSettings[];
}

interface IBooleanSettings {
    name: string;
    state: boolean;
    label: string;
}

export interface IDocumentStore {
    name: StoreNameEnum;
    fieldName?: string;
    value: string[];
}

export enum StoreNameEnum {lastSearchQuery = 'lastSearchQuery'}

export interface FavoriteMenuItem {
    key: string;           // уникальный ключ пункта меню
    parentKey?: string;    // ключ родительского меню (опционально)
    isFavorite: boolean;   // статус избранного
    addedAt?: number;      // timestamp для сортировки
    command?: string;
}

export interface MenuSettings {
    favorites: FavoriteMenuItem[];  // список избранных пунктов
}

export interface DocumentTabSettings {
    enabledFields: string[]; // ID полей, которые доступны для таба
    tabOrder: string[]; // Порядок табуляции
    autoSkipDisabled: boolean; // Автоматически пропускать отключенные поля
    documentSettings?: IDocumentSettings;
    documentStore?: IDocumentStore[];
}

export interface DocumentSettings {
    invoiceItemCreator: DocumentTabSettings;
    // другие документы...
}

export interface UISettings {
    alerts: AlertSettings;
    chat: ChatSettings;
    documents: DocumentSettings;
    tabBehavior: {
        cycle: boolean; // Циклическое перемещение
        rememberLastField: boolean; // Запоминать последнее активное поле
    };
    menu: MenuSettings;
}
